module.exports = __webpack_public_path__ + "static/about-profile-kinans-866e8d1919dac9fe929df3216371143b.png";